import { __awaiter, __generator } from "tslib";
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getQueryParams } from '@office-start/url-parser-utility';
import { httpGet } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
export function getUnifiedStorageQuota(_a) {
    var correlationId = _a.correlationId, jwtAuthEnabled = _a.jwtAuthEnabled, getAccessToken = _a.getAccessToken, graphApiRoot = _a.graphApiRoot, officeApiRoot = _a.officeApiRoot, inMockMode = _a.inMockMode;
    return __awaiter(this, void 0, void 0, function () {
        var requestConfig, apiPath, queryParams, hasMockAuth, apiRoot, url, used, total;
        return __generator(this, function (_b) {
            requestConfig = {
                method: "GET" /* HttpRequestMethod.Get */,
            };
            apiPath = "users/me/settings/storage/quota";
            queryParams = getQueryParams(location.search);
            hasMockAuth = queryParams['mockauth'] === '1';
            apiRoot = inMockMode ? "".concat(officeApiRoot, "/api") : graphApiRoot;
            url = getGraphServiceEndpoint(apiRoot, apiPath, true);
            if (hasMockAuth) {
                used = +queryParams['used'];
                total = +queryParams['total'];
                return [2 /*return*/, Promise.resolve({
                        total: total,
                        used: used,
                    })];
            }
            return [2 /*return*/, httpGet(KnownInstrumentationEvents.UnifiedStorageRequest, "Unified_Storage_Request" /* KnownRequestInstrumentationEvents.UnifiedStorageRequest */, url, requestConfig, jwtAuthEnabled, getAccessToken, officeApiRoot, correlationId, 'Graph')
                    .then(function (response) {
                    if (!response || !response.ok || response.data === undefined) {
                        throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'Graph API error');
                    }
                    return response.data;
                })
                    .catch(function (error) {
                    getErrorHandler().handleError(error, "WBFtm" /* ErrorId.WBFtm */);
                    return undefined;
                })];
        });
    });
}
//# sourceMappingURL=getUnifiedStorageQuota.js.map